import { useQuery } from '@tanstack/react-query';
import { myAssignedJobsCount } from '../api/assignments';

export const ASSIGNED_JOBS_QUERY_KEY = ['assigned-jobs'];
export const ASSIGNED_JOBS_COUNT_QUERY_KEY = ['assigned-jobs', 'count'];

/** Open (not yet completed) jobs assigned to the signed-in user, for the sidebar badge. */
export function useAssignedJobsCount() {
  const query = useQuery({
    queryKey: ASSIGNED_JOBS_COUNT_QUERY_KEY,
    queryFn: myAssignedJobsCount,
    refetchInterval: 60_000,
  });

  return query.data ?? 0;
}
